module.exports = __webpack_public_path__ + "public/img/no_result.07137474.png";